export const PHOTOS_REQUIRED = 1;
export const PHOTO_SLOT_COUNT = 16;
export const PHOTOS_LIVE_VIEW_THRESHOLD = 6;
export const PAYOFF_PLAUSIBILITY_BOOK_VALUE_RATIO = 0.4;
export const PAYOFF_PLAUSIBILITY_FLOOR = 5_000;
